<template>
  <div class="section_wrap">
    <div class="head">
      <div class="head-center">
        <div class="title">
          <div class="title-text">直播</div>
        </div>
      </div>
      <div class="head-right"></div>
    </div>
    <div class="body">
      <div class="showcase">
        <div class="goods-list" v-if="list.length > 0">
          <div class="goods-item" v-for="(item, index) in list" :key="index">
            <div class="goods-item-img">
              <template>
                <div class="goods-img" @click="todetail(item)" v-if="item.cover">
                  <el-image class="image" :src="item.cover" @error="handleError" />
                </div>
                <div class="default-img" @click="todetail(item)" v-else>
                  <el-image class="image" :src="goodsimage" />
                </div>
              </template>
            </div>
            <div class="goods-item-info">
              <div class="title ellipsis">{{ item.title }}</div>
              <div class="content">
                <div class="tags ellipsis">
                  <el-tag class="tag" size="small" :type="item.status === 1 ? '' : 'danger'">
                    <img class="icon" :src="item.status === 1 ? liveStateImg02 : liveStateImg01 " />
                    {{ item.status | stateFilter }}
                  </el-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="no-data" v-else>~暂无数据~</div>
        <div class="more-contain" v-if="isMore">
          <div class="more" @click="handleMore">
            <div class="more-title">更多</div>
            <div class="more-icon">
              <el-image class="elimage" :src="moreicon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const stateMap = {
  0: "未开始",
  1: "直播中",
  3: "直播已结束"
}
export default {
  name: "search-live",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => new Array(),
    },
    isMore: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    stateFilter (status) {
      return stateMap[status]
    },
  },
  data () {
    return {
      liveStateImg01: require("@/assets/home/locking.png"),
      liveStateImg02: require("@/assets/home/live_streaming.png"),
      moreicon: require("@/assets/home/open.png"),
      goodsimage: require("@/assets/default/image02.jpg"),
    }
  },
  watch: {
    list: {
      handler (newV) {
        if (newV.length) {
          let currentTime = parseInt(new Date().getTime() / 1000)
          newV = newV.map(ele => {
            if (ele.start_time > currentTime) { // 未开始
              ele.status = 0
            } else {
              ele.status = 1
            }
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {},
  mounted () { },
  methods: {
    handleError (e) {
      // 当图片加载失败时，将图片地址设置为默认图片
      e.target.src = this.goodsimage
      // 可以添加额外的处理，比如提示用户或者进行日志记录
    },
    handleMore () {
      this.$emit("more", 5)
    },
    todetail (item) {
      window.localStorage.setItem("menuId", 4)
      this.$store.dispatch("setmenuid", 4)
      this.$router.push({
        path: "/move",
        query: {
          sn: item.sn,
        },
      })
    },
  },
};
</script>
<style scoped lang="scss">
.section_wrap {
  width: 100%;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    .head-left {
      width: 64px;
    }
    .head-center {
      // flex: 1;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        .title-icon {
          width: 32px;
          min-width: 32px;
          height: 32px;
          margin-left: 10px;
          .elimage {
            width: 100%;
            height: 100%;
          }
        }
        .title-text {
          color: #000;
          font-size: 30px;
          font-weight: bold;
          line-height: 40px;
        }
      }
    }
    .head-right {
      .more {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 40px;
        margin-left: 15px;
        .elimage {
          width: 38px;
          height: 38px;
        }
      }
    }
  }
  .body {
    .showcase {
      margin: 0 -10px;
      .goods-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .goods-item {
          width: calc((100% - 120px) / 5);
          height: 325px;
          background-color: #fff;
          border: 1px solid transparent;
          // box-shadow: 0px 0px 29px 0px rgb(0 80 179 / 8%);
          border-radius: 5px;
          overflow: hidden;
          margin: 10px 10px;
          flex-shrink: 1;
          cursor: pointer;
          // &:hover {
          //   border: 1px solid rgb(9, 235, 178);
          // }
          .goods-item-img {
            position: relative;
            .goods-img {
              width: 100%;
              height: 235px;
              background: aliceblue;
              .image {
                display: inline-block;
                -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
                -webkit-transition-property: transform;
                transition-property: transform;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                box-shadow: 0 0 1px rgba(0, 0, 0, 0);
              }

              .image:hover,
              .image:focus,
              .image:active {
                -webkit-transform: scale(1.1);
                transform: scale(1.1);
              }

              .image {
                width: 100%;
                height: 100%;
              }
            }
            .default-img {
              width: 100%;
              height: 235px;
              // background: #daebfc;
              text-align: center;
              background: aliceblue;
              .image {
                display: inline-block;
                -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
                -webkit-transition-property: transform;
                transition-property: transform;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                box-shadow: 0 0 1px rgba(0, 0, 0, 0);
              }
              .image:hover,
              .image:focus,
              .image:active {
                -webkit-transform: scale(1.1);
                transform: scale(1.1);
              }
              .image {
                width: 100%;
                height: 100%;
              }
            }
          }
          .goods-item-info {
            padding: 10px 15px;
            background: #ffffff;
            // border: 1px solid red;
            .title {
              color: #000;
              font-size: 16px;
              font-weight: 500;
              line-height: 40px;
            }
            .content {
              .tit,
              .txt {
                color: #999;
                font-size: 12px;
                font-weight: 400;
                height: 20px;
                line-height: 20px;
                padding: 2px 5px;
                border-radius: 12px;
                margin-bottom: 10px;
              }
              .time {
                margin-bottom: 10px;
              }
              .tags {
                .tag {
                  border-radius: 20px;
                  .icon {
                    width: 16px;
                    height: 16px;
                    vertical-align: text-bottom;
                  }
                }
              }
            }
          }
        }
      }
      .no-data {
        height: 60px;
        line-height: 60px;
        text-align: center;
      }
      .more-contain {
        .more {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 28px;
          padding: 2px 20px;
          user-select: none;
          cursor: pointer;
          .more-title {
            color: #005292;
            font-size: 14px;
            font-weight: 400;
          }
          .more-icon {
            margin-left: 10px;
            .elimage {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 640px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 18x;
            height: 18px;
          }
          .title-text {
            font-size: 18px;
          }
        }
      }
      .head-right {
        .more {
          margin-left: 5px;
          .elimage {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    .body {
      .showcase {
        margin: 0;
        .goods-list {
          .goods-item {
            width: calc((100% - 26px) / 2);
            margin: 5px 5px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 640px) and (max-width: 1200px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 24px;
            height: 24px;
          }
          .title-text {
            font-size: 24px;
          }
        }
      }
      .head-right {
        .more {
          margin-left: 10px;
          .elimage {
            width: 26px;
            height: 26px;
          }
        }
      }
    }
    .body {
      .showcase {
        .goods-list {
          .goods-item {
            width: calc((100% - 90px) / 4);
            margin: 10px 10px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 32px;
            height: 32px;
          }
          .title-text {
            font-size: 30px;
          }
        }
      }
      .head-right {
        .more {
          .elimage {
            width: 38px;
            height: 38px;
          }
        }
      }
    }
    .body {
      .showcase {
        .goods-list {
          .goods-item {
            width: calc((100% - 120px) / 5);
            margin: 10px 10px;
          }
        }
      }
    }
  }
}
</style>
